import { render } from "./AppLayoutDashboard.vue?vue&type=template&id=18a79cf2"
import script from "./AppLayoutDashboard.vue?vue&type=script&lang=js"
export * from "./AppLayoutDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ayion/dev/dork/fmoj-vacms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__